module.exports = __webpack_public_path__ + "img/38.4.NH3-N.ac669f47.png";